import { useConfirmModal } from '@/components/ConfirmationModal';

import { useMemo } from 'react';

import { ConfirmModalArgs } from '@/components/ConfirmationModal';
import { ApPayee } from '@/components/ReportForm/Modals/ChangeXXX/ApPayee/ApPayee';
import { SelectedType } from '@/components/ReportForm/Modals/ChangeXXX/type';
import { useTranslation } from '@/i18n';

export const useConfirm = (
  onChangeSelectedOption: (value: SelectedType) => void
) => {
  const { t } = useTranslation();
  const args: ConfirmModalArgs = useMemo(
    () => ({
      size: 'md',
      title: t('invoice_reports.change_range_selection'),
      body: <ApPayee defaultValue='all' onChange={onChangeSelectedOption} />,
      okButtonProps: {
        color: 'primary',
        children: t('change'),
      },
    }),
    [t, onChangeSelectedOption]
  );
  return useConfirmModal(args);
};
